import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import BrandStory from './components/BrandStory';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash !== '#about') return;
    // 商品グリッドが非同期で読み込まれるとレイアウト高が変わるため、少し遅らせて再スクロールする
    const scroll = () => document.getElementById('about')?.scrollIntoView({ behavior: 'auto' });
    scroll();
    const timer = setTimeout(scroll, 400);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <BrandStory />
      </main>
      <Footer />
    </div>
  );
}
